<template>
  <transition mode="out-in">
    <div
      id="cp-sidebar"
      class="v-sidebar-menu menu-tree container-fluid"
      :class="{'collapsed':isCollapsed || $mq !== 'desktop'}"
    >
      <div class="pt-3 pb-1 ml-1">
        <div class="row">
          <div class="col-12" v-if="!isCollapsed && $mq === 'desktop'">
            <h5 class="font-weight-bold">
              <i class="fas fa-tachometer-alt fa-lg pr-2"></i>
              {{title}}
            </h5>
          </div>
          <div
            v-else
            class="px-1 pb-1 ml-1 d-flex justify-content-center my-auto mobile-bg"
            @click="showDropdown=!showDropdown"
          >
            <i class="mb-2 fas fa-tachometer-alt fa-lg"></i>
          </div>
        </div>
      </div>
      <hr v-if="!isCollapsed && $mq === 'desktop'" width="99%" class="my-0 bg-secondary" />
      <div v-if="!isCollapsed && $mq === 'desktop'">
        <div v-for="(menuItem, index) in menu" :key="index">
          <menu-item
            :menuItem="menuItem"
            :menu="menu"
            :isCollapsed="isCollapsed"
            @item-selected="onMenuItemClick"
            :isOpen="menuItem.meter.Serial == activeMeter.Serial"
            :expandAll="menuItem.meter.Serial == activeMeter.Serial"
          />
        </div>
      </div>
      <dropdown :menu="menu" @item-selected="onMenuItemClick" v-else-if="showDropdown" />
      <button class="collapse-btn" @click="toggleCollapse" v-if="$mq === 'desktop'"></button>
    </div>
  </transition>
</template>

<script>
import MenuItem from "./MenuItem";

export default {
  props: ["menu", "title"],
  data() {
    return {
      isCollapsed: false,
      showDropdown: false
    };
  },
  components: {
    MenuItem
  },
  computed: {
    activeService: {
      get() {
        return this.$store.state.meters.activeService;
      },
      set(service) {
        this.$store.commit("updateActiveService", service);
      }
    },
    activeMeter() {
      return this.$store.state.meters.activeMeter;
    },
    services() {
      return this.$store.state.contracts.services;
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      this.$emit("toggle-collapse", this.collapsed);
    },
    onMenuItemClick(items) {
      this.$store.dispatch("changeActiveMeter", items[0].meter);
    }
  }
};
</script>